export enum EDTFType {
    DATE_COMPLETE = 'DATE_COMPLETE',
    DATE_PRECISION_YEAR_AND_MONTH = 'DATE_PRECISION_YEAR_AND_MONTH',
    DATE_PRECISION_YEAR = 'DATE_PRECISION_YEAR',
    NEGATIVE_CALENDER_YEAR = 'NEGATIVE_CALENDER_YEAR',
    DATETIME_COMPLETE = 'DATETIME_COMPLETE',
    DATETIME_COMPLETE_UTC = 'DATETIME_COMPLETE_UTC',
    DATETIME_COMPLETE_SHIFT = 'DATETIME_COMPLETE_SHIFT',
    TIME_INTERVAL = 'TIME_INTERVAL',
    LETTER_PREFIXED_YEAR = 'LETTER_PREFIXED_YEAR',
    SEASONS = 'SEASONS',
    DATE_QUALIFICATION_UNCERTAIN = 'DATE_QUALIFICATION_UNCERTAIN',
    DATE_QUALIFICATION_APPROXIMATE = 'DATE_QUALIFICATION_APPROXIMATE',
    DATE_QUALIFICATION_UNCERTAIN_APPROXIMATE = 'DATE_QUALIFICATION_UNCERTAIN_APPROXIMATE',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DECADE = 'UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DECADE',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_CENTURY = 'UNSPECIFIED_DIGIT_FROM_THE_RIGHT_CENTURY',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_MONTH = 'UNSPECIFIED_DIGIT_FROM_THE_RIGHT_MONTH',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_YEAR = 'UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_YEAR',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_MONTH = 'UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_MONTH',
    EXTENDED_INTERVAL = 'EXTENDED_INTERVAL',
    EXTENDED_INTERVAL_OPEN_END = 'EXTENDED_INTERVAL_OPEN_END',
    EXTENDED_INTERVAL_OPEN_BEGIN = 'EXTENDED_INTERVAL_OPEN_BEGIN',
    EXTENDED_INTERVAL_UNKNOWN_END = 'EXTENDED_INTERVAL_UNKNOWN_END',
    EXTENDED_INTERVAL_UNKNOWN_BEGIN = 'EXTENDED_INTERVAL_UNKNOWN_BEGIN',
    COMPLETELY_UNSPECIFIED = 'COMPLETELY_UNSPECIFIED'
}
